const QUARTER_SIZE = 3;

function getQuarterIndex(date) {
    return Math.min(Math.floor(date.getMonth() / QUARTER_SIZE), 3);
}


export function changeQuarter(delta = 0) {
    const from = new Date();
    from.setMonth(getQuarterIndex(from) * QUARTER_SIZE, 1);
    from.setHours(0, 0, 0, 0);
    from.setMonth(from.getMonth() + (delta * QUARTER_SIZE), 1);

    const to = new Date(from);
    to.setMonth(from.getMonth() + QUARTER_SIZE, 1);

    return [ from, new Date(to.getTime() - 1) ];
}


export function collect(source) {
    let value = 0;
    let delta = 0;

    for (const key in source) {
        const it = source[key];
        value += it.value;
        delta += it.delta;
    }

    return {
        value,
        delta,
    };
}


export const PROCESS_COLOR_MAPPING = {
    1: 'blue',
    2: 'yellow',
    3: 'red',
    4: 'orange',
    5: 'purple',
    6: 'green',
};


export function linearScale(max, value, min) {
    const result = value / max;

    if (result < min)
        return min;

    return result;
}


export function logarithmicScale(max, value, min) {
    if (value === 0)
        return min;

    let result = ((100 - min) * (Math.log(value) / Math.log(max))) + min;
    if (result <= min)
        return min;

    return result / 100;
}


export function deltaFormat(value) {
    let suffix = '';
    if (value >= 0)
        suffix = '+';

    return suffix + value;
}


export function toCss(value) {
    return (100 * value).toFixed(3) + '%';
}


// Форматирование ссылки для аналитики
export function redirectUrl(url) {
    if (typeof (url) !== 'string')
        throw new TypeError('Parameter [1] is not a string');

    if (!url.length > 0)
        return url;

    // если урл совпадает с текущим доменом, то не добавляем к нему параметр
    const newUrl = new URL(url);
    if (newUrl.origin === location.origin)
        return url;

    return `${ location.origin }/api/redirect?to=${ encodeURIComponent(url) }`;
}
